import {
  POST_PREPARING_FOR_ARCHIVE,
  POST_PREPARING_FOR_ARCHIVE_ERROR,
  POST_CREATE_ARCHIVE,
  POST_CREATE_ARCHIVE_ERROR,
  MANUALLY_TRIGGER_MESSAGE,
  DELETE_ARCHIVED_ITEM,
  GET_ARCHIVE,
  GET_CURRENT_YEAR_ARCHIVE,
  GET_ARCHIVE_NUMBER,
  GET_CURRENT_YEAR_ARCHIVE_NUMBER,
  GET_ARCHIVES_FOR_DESTROYING,
  UPDATE_ARCHIVE,
  UPDATE_ARCHIVE_ERROR,
  GET_ARHIVE_FOR_WORD,
  GET_ARHIVE_FOR_WORD_ERROR,
  GET_CERTAIN_ARCHIVE,
  GET_CERTAIN_ARCHIVE_ERROR,
  UPDATE_CERTAIN_ARCHIVE,
  UPDATE_CERTAIN_ARCHIVE_ERROR
} from "../types";

export const archiveReducer = (state = [], action) => {
  switch (action.type) {
    case POST_PREPARING_FOR_ARCHIVE:
      return { ...state, prepareArchiveData: action.payload };
    case POST_PREPARING_FOR_ARCHIVE_ERROR:
      return { ...state, prepareArchiveDataError: action.payload };
    case POST_CREATE_ARCHIVE:
      return {
        ...state,
        archiveData: action.payload,
        archiveDataError: "Успешно сте архивирали документа"
      };
    case POST_CREATE_ARCHIVE_ERROR:
      return { ...state, archiveDataError: action.payload };
    case MANUALLY_TRIGGER_MESSAGE:
      return { ...state, archiveDataError: "" };
    case DELETE_ARCHIVED_ITEM:
      return { ...state, prepareArchiveData: action.payload };
    case GET_ARCHIVE:
      return { ...state, allArchive: action.payload };
    case GET_CURRENT_YEAR_ARCHIVE:
      return { ...state, currentYearArchive: action.payload };
    case GET_ARCHIVE_NUMBER:
      return { ...state, allArchiveNumber: action.payload };
    case GET_CURRENT_YEAR_ARCHIVE_NUMBER:
      return { ...state, currentYearArchiveNumber: action.payload };
    case GET_ARCHIVES_FOR_DESTROYING:
      return { ...state, archivedItemsForDestroying: action.payload };
    case UPDATE_ARCHIVE:
      return {
        ...state,
        updateArchiveMessage: action.payload.message,
        updateArchiveStatus: action.payload.status
      };
    case UPDATE_ARCHIVE_ERROR:
      return {
        ...state,
        archiveDataError: action.payload.message,
        updateArchiveErrorStatus: action.payload.status
      };
    case GET_ARHIVE_FOR_WORD:
      return { ...state, arhiveForWord: action.payload };
    case GET_ARHIVE_FOR_WORD_ERROR:
      return { ...state, arhiveForWord: action.payload };
    case GET_CERTAIN_ARCHIVE:
      return { ...state, certainArchive: action.payload };
    case GET_CERTAIN_ARCHIVE_ERROR:
      return { ...state, certainArchiveError: action.payload };
    case UPDATE_CERTAIN_ARCHIVE:
      return {
        ...state,
        status: action.payload.status,
        updateArchiveMessage: action.payload.message
      };
    case UPDATE_CERTAIN_ARCHIVE_ERROR:
      return {
        ...state,
        status: action.payload.status,
        updateArchiveMessage: action.payload.message
      };
    default:
      return state;
  }
};
